var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJustify(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5574 0.961792H0.271548C0.153734 0.961792 0.0582275 1.0205 0.0582275 1.09292V2.01495C0.0582275 2.08737 0.153734 2.14608 0.271548 2.14608H13.5574C13.6752 2.14608 13.7707 2.08737 13.7707 2.01495V1.09292C13.7707 1.0205 13.6752 0.961792 13.5574 0.961792Z",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5574 11.4331H0.271548C0.153734 11.4331 0.0582275 11.4918 0.0582275 11.5643V12.4863C0.0582275 12.5587 0.153734 12.6174 0.271548 12.6174H13.5574C13.6752 12.6174 13.7707 12.5587 13.7707 12.4863V11.5643C13.7707 11.4918 13.6752 11.4331 13.5574 11.4331Z",
    fill: "#222222"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5574 7.94269H0.271548C0.153734 7.94269 0.0582275 8.0014 0.0582275 8.07382V8.99584C0.0582275 9.06827 0.153734 9.12698 0.271548 9.12698H13.5574C13.6752 9.12698 13.7707 9.06827 13.7707 8.99584V8.07382C13.7707 8.0014 13.6752 7.94269 13.5574 7.94269Z",
    fill: "#222222"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5574 4.45224H0.271548C0.153734 4.45224 0.0582275 4.51095 0.0582275 4.58337V5.5054C0.0582275 5.57782 0.153734 5.63653 0.271548 5.63653H13.5574C13.6752 5.63653 13.7707 5.57782 13.7707 5.5054V4.58337C13.7707 4.51095 13.6752 4.45224 13.5574 4.45224Z",
    fill: "#222222"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJustify);
export default __webpack_public_path__ + "static/media/justify.a275e191c1beeb967cd2606e615e126d.svg";
export { ForwardRef as ReactComponent };